// extracted by mini-css-extract-plugin
export default {"ant-page-header":"styles_ant-page-header__kKNLk","ant-page-header-heading-title":"styles_ant-page-header-heading-title__CmqxC","table":"styles_table__IoNyA"};